import FileSaver from "file-saver";
var EdelFileSaver = /** @class */ (function () {
    function EdelFileSaver() {
    }
    EdelFileSaver.prototype.saveFile = function (file) {
        FileSaver.saveAs(file);
    };
    return EdelFileSaver;
}());
export { EdelFileSaver };
